export default [
  {id: 1, codigo: 'SEMOVENTES', label: 'Semoventes (Animais)'},
  {id: 2, codigo: 'CULTURA_PERMANENTE', label: 'Cultura Permanente'},
  {id: 3, codigo: 'SILVICULTURA', label: 'Silvicultura'},
  {id: 4, codigo: 'MANEJO_FLORESTAL', label: 'Manejo Florestal'},
  {id: 5, codigo: 'OUTRAS_ATIVIDADES', label: 'Outras Atividades'},
  {id: 6, codigo: 'EDIFICACOES', label: 'Edificações'},
  {id: 7, codigo: 'CULTURA_TEMPORARIA', label: 'Cultura Temporária'}
]



// WEBPACK FOOTER //
// ./src/utils/tiposAtividades.js